module.exports = __webpack_public_path__ + "img/base.f1294952.png";